import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getDecisionListFilterFilters = (state: IRootState) => state.decisionListFilter.filters;
export const getDecisionListFilterCurrentFilter = (state: IRootState) => state.decisionListFilter.current;
export const getDecisionListFilterIsFilterOn = (state: IRootState) => state.decisionListFilter.isFilterOn;
export const getDecisionListFilterCurrentId = (state: IRootState) => state.decisionListFilter.currentId;
export const getDecisionListCurrentControlOrganizations = (state: IRootState) =>
  state.decisionListFilter.currentControlOrganizations;
export const getDecisionListCurrentSupervisionTypes = (state: IRootState) =>
  state.decisionListFilter.currentSupervisionTypes;
